import { withTranslation } from 'react-i18next';

function Home({ t }) {
    const tours = [
        {
            title: t("tours.tour_list.terelj.title"),
            description: t("tours.tour_list.terelj.description"),
            img_source: "/imgs/tours/gorkhi_terelj.jpeg"
        },
        {
            title: t("tours.tour_list.turtle_rock.title"),
            description: t("tours.tour_list.turtle_rock.description"),
            img_source: "/imgs/tours/terelj.jpg"
        },
        {
            title: t("tours.tour_list.aryabal.title"),
            description: t("tours.tour_list.aryabal.description"),
            img_source: "/imgs/tours/aryabal.jpg"
        },
    ]

    return (
        <div>
            <div className="sm:h-full h-screen bg-cover">
                <img className='h-full w-full object-cover' src="/imgs/test_img1.jpg" alt="Mongolia" />
            </div>
            <div className="text-center sm:text-5xl text-4xl font-bold text-secondary mt-6">{t("home.catchphrase.title")}</div>
            <div className="grid sm:grid-cols-3 grid-cols-1 gap-12 px-12 pb-12 pt-6">
                <div>
                    <div className="text-center p-4">
                        <div>
                            <img src="/imgs/mongolia.jpg" />
                        </div>
                    </div>
                    <div className="text-center p-4">
                        <div className="font-bold text-secondary text-2xl">{t("home.catchphrase.phrase1_title")}</div>
                        <div className="mt-6">{t("home.catchphrase.phrase1_text")}</div>
                    </div>
                </div>
                <div>
                    <div className="text-center p-4">
                        <div>
                            <img src="/imgs/nomads.jpg" />
                        </div>
                    </div>
                    <div className="text-center p-4">
                        <div className="font-bold text-secondary text-2xl">{t("home.catchphrase.phrase2_title")}</div>
                        <div className="mt-6">{t("home.catchphrase.phrase2_text")}</div>
                    </div>
                </div>
                <div>
                    <div className="text-center p-4">
                        <div>
                            <img src="/imgs/country.jpg" />
                        </div>
                    </div>
                    <div className="text-center p-4">
                        <div className="font-bold text-secondary text-2xl">{t("home.catchphrase.phrase3_title")}</div>
                        <div className="mt-6">{t("home.catchphrase.phrase3_text")}</div>
                    </div>
                </div>
            </div>
            <div className="text-center text-secondary font-bold sm:text-5xl text-4xl">{t("home.tours")}</div>
            <div className="grid sm:grid-cols-3 grid-cols-1 px-12 py-12 mt-12 gap-8">
                {tours.map(tour =>
                    <div key={tour.title} className="block bg-white border border-gray-200 rounded-lg shadow-sm grid grid-cols-1">
                        <div className="h-72 w-full">
                            <img src={tour.img_source} className="rounded-t-lg w-full h-full object-cover" alt="tag" />
                        </div>
                        <div className="p-4">
                            <div className="font-bold text-2xl text-center text-secondary">{tour.title}</div>
                            <div className='mt-2 text-center text-[14px]'>{tour.description}</div>
                        </div>
                    </div>
                )}
            </div>
            <div className="text-center pb-12"><a href="/tours" className="bg-secondary text-white p-2 rounded-full font-bold">{t("home.see_more")}</a></div>
        </div>
    )
}

export default withTranslation()(Home);